<div class="grid grid-cols-[minmax(320px,500px)_minmax(400px,1fr)] gap-4 w-full">
   <section
      class="flex flex-col"
      id="sidebar"
   >
      <div class="left-side pl-4">
         <ng-container [ngTemplateOutlet]="sideContentTop"></ng-container>
         <div
            #scrollContainer
            (scrolled)="onScroll()"
            [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="100"
            [scrollWindow]="false"
            class="left-side__scroll-area c-scroll-wrapper c-scroll-wrapper--transparent-thumb"
            infiniteScroll
         >
            <ng-container [ngTemplateOutlet]="sideContent"></ng-container>

            <div class="pt-40"></div>

            <div
               class="flex justify-center w-full"
               id="scroll-fallback"
            >
               @if (!showScrollFallback.loading && showScrollFallback.hasNextPage) {
                  <button
                     (click)="onScroll()"
                     [color]="'primary'"
                     class="items-center self-center my-4"
                     mat-raised-button
                  >
                     {{ 'general.load_more_results' | translate }}
                  </button>
               }

               @if (!showScrollFallback.loading && !showScrollFallback.hasNextPage) {
                  <div>
                     @if (showScrollFallback?.template) {
                        <ng-template [ngTemplateOutlet]="showScrollFallback.template"></ng-template>
                     }
                     @if (!showScrollFallback?.template) {
                        <div class="items-center self-center py-8">{{ 'general.all_results_loaded' | translate }}.</div>
                     }
                  </div>
               }
            </div>
         </div>
      </div>
   </section>
   <!-- A flex column down to the content: the routed detail sizes itself with flex-auto -->
   <shared-ui-card class="sheet-main mr-4 @container/main flex flex-col">
      <shared-ui-card-content class="flex flex-col flex-auto min-h-0">
         <div class="w-full flex flex-col flex-auto min-h-0">
            <ng-container
               [ngTemplateOutlet]="content"
               class="block"
            ></ng-container>
         </div>
      </shared-ui-card-content>
   </shared-ui-card>
</div>
